export default "__VITE_ASSET__BF5dmq0K__"